"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationSearchListResponseSchema = exports.ApplicationSearchListResultSchema = exports.ApplicationSearchItemSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
exports.ApplicationSearchItemSchema = zod_1.z.object({
    appliedAt: schemas_1.ISODateSchema,
    candidate: zod_1.z.object({
        firstName: zod_1.z.string(),
        id: schemas_1.UUIDSchema,
        lastName: zod_1.z.string(),
    }),
    id: schemas_1.UUIDSchema,
    recruitment: zod_1.z.object({
        id: schemas_1.UUIDSchema,
        title: zod_1.z.string(),
    }),
    status: zod_1.z.string(),
});
exports.ApplicationSearchListResultSchema = zod_1.z
    .object({ applications: exports.ApplicationSearchItemSchema.array() })
    .extend(schemas_1.PaginationResponseSchema.shape);
exports.ApplicationSearchListResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.ApplicationSearchListResultSchema);
